import OSS from "ali-oss";
import { GetDepartmentStsToken } from "@/api/home";

let cachedSts = null;

function credentialsAreValid(sts) {
  if (!sts || !sts.AccessKeyId || !sts.AccessKeySecret || !sts.SecurityToken) return false;
  const expiresAt = Date.parse(sts.Expiration || "");
  return Number.isFinite(expiresAt) && expiresAt - Date.now() > 120000;
}

async function getSts() {
  if (credentialsAreValid(cachedSts)) return cachedSts;
  cachedSts = await GetDepartmentStsToken();
  if (!credentialsAreValid(cachedSts)) throw new Error("OSS 临时上传凭证无效");
  return cachedSts;
}

function fileExtension(file) {
  const extension = String(file.name || "").split(".").pop().toLowerCase();
  return /^[a-z0-9]{2,5}$/.test(extension) ? extension : "jpg";
}

function randomHex() {
  return `${Math.random().toString(16).slice(2)}${Math.random().toString(16).slice(2)}`.slice(0, 16);
}

function createClient(sts) {
  return new OSS({
    region: "oss-cn-hangzhou",
    bucket: "naae",
    accessKeyId: sts.AccessKeyId,
    accessKeySecret: sts.AccessKeySecret,
    stsToken: sts.SecurityToken,
    secure: true,
  });
}

export async function uploadDepartmentPhoto(file, photoType = "family") {
  let sts = await getSts();
  const objectKey = `later/family_photo/${Date.now()}_${randomHex()}.${fileExtension(file)}`;
  try {
    await createClient(sts).put(objectKey, file);
  } catch (error) {
    if (!/security token|accesskey|expired|forbidden|signature/i.test(error.message || "")) throw error;
    cachedSts = null;
    sts = await getSts();
    await createClient(sts).put(objectKey, file);
  }
  const host = String(sts.host || "naae.oss-cn-hangzhou.aliyuncs.com").replace(/^https?:\/\//, "");
  return {
    url: `https://${host}/${objectKey}`,
    object_key: objectKey,
    file_name: file.name || "",
    mime_type: file.type || "",
    file_size: Number(file.size || 0),
    photo_type: photoType,
  };
}
